import { useEffect } from "react";

const SCRIPT_ID = "cuo-jsonld";

export function JsonLdScript({ data }: { data?: unknown }) {
  useEffect(() => {
    let el = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (!data) {
      el?.remove();
      return;
    }
    if (!el) {
      el = document.createElement("script");
      el.id = SCRIPT_ID;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, [data]);

  return null;
}
